import React from 'react';

const Credits = () => {
  return (
    <div>
      <h2>Credits</h2>
      <p>
        The development of this kit was made possible by using the following resources. We thank the people behind them for their openness and constant work to keep them live and updated.
      </p>
      <ul>
        <li>
          Bootstrap - <a href="https://getbootstrap.com" target="_blank" rel="noopener noreferrer">https://getbootstrap.com</a>
        </li>
        <li>
          Reactstrap - <a href="https://reactstrap.github.io/" target="_blank" rel="noopener noreferrer">https://reactstrap.github.io/</a>
        </li>
        <li>
          Create React App - <a href="https://github.com/facebook/create-react-app" target="_blank" rel="noopener noreferrer">https://github.com/facebook/create-react-app</a>
        </li>
        <li>
          React Router Dom - <a href="https://www.npmjs.com/package/react-router-dom" target="_blank" rel="noopener noreferrer">https://www.npmjs.com/package/react-router-dom</a>
        </li>
        <li>
          Font Awesome React - <a href="https://www.npmjs.com/package/@fortawesome/react-fontawesome" target="_blank" rel="noopener noreferrer">https://www.npmjs.com/package/@fortawesome/react-fontawesome</a>
        </li>
        <li>
          No UI Slider - <a href="https://www.npmjs.com/package/nouislider-react" target="_blank" rel="noopener noreferrer">https://www.npmjs.com/package/nouislider-react</a>
        </li>
        <li>
          Google Fonts - <a href="https://fonts.google.com" target="_blank" rel="noopener noreferrer">https://fonts.google.com</a>
        </li>
        <li>
          Unsplash - <a href="https://unsplash.com" target="_blank" rel="noopener noreferrer">https://unsplash.com</a>
        </li>
      </ul>
    </div>
  );
};

export default Credits;
